import { watchEmbeds } from "./attach";

// The snippet's iframe has to have been parsed before it can be found. `defer`
// on the script tag gives that, and the readyState check covers the snippet
// being pasted somewhere that does not: a tag manager's custom HTML block, or
// a <script> an admin has moved into <head> without it.
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => watchEmbeds());
} else {
  watchEmbeds();
}
